jQuery3_4_1(document).ready(function($){
    class HotspotManager {
        init(){
            if ( DDPlatform.device.isTouchOnly() ) {
                this.registerTouchTooltipToggle();
            }
        }

        registerTouchTooltipToggle(){
            $(document).on( "click" , ".dd-hotspot" , function(){
                const $hotspot = $(this);
                const $tooltip = $hotspot.find("[data-tooltip]");
                const isNone = $hotspot.data("function") === "none";
                const wasActive = $tooltip.hasClass("dd-tooltip-active");
                $(".dd-tooltip-active").removeClass("dd-tooltip-active");
                if ( isNone && !wasActive ) {
                    $tooltip.addClass("dd-tooltip-active");
                }
            });
        }
    }

    const hotspotManager = new HotspotManager();
    hotspotManager.init();
});